if (!window.Buffer && global) {
  global.Buffer = require('buffer').Buffer
}

if (!window.location && global) {
  global.location = {
    protocol: 'file:',
  }
}